<template>
    <div class="pressForMoneyDetail">
        <div class="top-tips" v-if="show" @click="goSkill">
            <p class="tips-text">催款技巧说明了解一下</p>
            <img src="../../assets/img/icon_close_p.png"  @click.stop="show=false">
        </div>
        <div class="contain-box" v-if="pressList && pressList.length>1">
            <div class="skill-item" v-for="(item, index) in pressList" :key="index">
                <div class="skill-title"><p class="skill-icon"  :style="{'border': (index == 1  && pressList[0].status !=2) || (index == 0 && item.status == 2) ? '3px solid rgba(255, 220, 220, 1)': '3px solid #fff'}" :class="[item.status == 1 && item.pressTypeName == '车费到账' ? 'dis-icon' : '' ]" ></p>{{item.pressTypeName}}</div>
                <div class="skill-desc active-line" :style="{'border': index == pressList.length -1 ? 'none': '', 'padding-bottom': index == pressList.length -1 ? '0': '' }" :class="[item.status == 1 && item.pressTypeName == '车费到账' ? 'dis-line' : '' ]">{{item.pressTypeName == '车费到账' ?  '车费到账' : item.createTime}}</div>
            </div>
        </div>
        <div class="empty-class" v-if="pressList.length == 1">
            <img src="../../assets/img/empty-press.png">
            <p>暂无催款进度</p>
        </div>
    </div>
</template>
<script>
import mobileType from "@/utils/mobileType";
import utils from "@/utils/util";
import { getPressList } from "@/apis/order/order";
export default {
    name: "pressForMoneyDetail",
    data() {
        return {
            show: true,
            pressList: [],
            params: {
                scale: "2.0",
                areaCode: "110105",
                sysVersion: "14.7",
                token:"MTAxNzAwNjgxOjcwMDoyMDIzMDUyMzE0NDQxMzgwNzpDRkY5NUM3RC00RUE2LTRBMUQtOUUzMS1ENUNCRDJFMDE5MDk=",
                appChannel: "AppStore",
                platform: "2",
                softVersion: "1.2.51",
                display: "1334*750",
                role: "2",
                uuidString: "7021747C-162F-46D9-8761-99AA3621013A",
                channel: "1020000000",
                cityCode: "110100",
                idfv: "912FD003-76D6-4DAC-B98C-4B6FFF5A00C6"
            },
        };
    },
    created() {
        window.getDataFromNative = this.getDataFromNative;
    },
    mounted() {
        this.getUserInfoFromApp();
        wsdata.track('DJ_PressPaymentPageView', {
            page_path: window.location.origin + '/home/pressForMoneyDetail'
        })
    },
    computed: {},
    methods: {
        getUserInfoFromApp() {
            let params = {
                methodName: "getDataFromNative", //定义与原生的方法名(固定)
                type: 1 //业务类型(固定)
            };
            if (mobileType.isIOS()) {
                window.webkit.messageHandlers.getDataFromVue.postMessage(
                    params
                );
            } else if (mobileType.isAndroid()) {
                window.Android.getDataFromVue(JSON.stringify(params));
            }
        },
        getDataFromNative(params) {
            if (mobileType.isIOS()) {
                this.params = params;
            } else if (mobileType.isAndroid()) {
                this.params = JSON.parse(params);
            }
            this.getPressListInit()
        },
        async getPressListInit() {
            let params = { ...this.params };
            params.data = JSON.stringify({
                orderId:  this.$route.query.orderId
            });
            try {
                const res = await getPressList(params);
                if (res.code == 1) {
                    let resData = JSON.parse(res.data);
                    this.pressList = resData
                } else {
                    Toast(res.msg)
                }
            } catch (error) {
                console.log(error);
            }
        },
        goSkill() {
            this.$router.push({
                path: '/home/pressForMoneySkill'
            })
        }
    }
};
</script>
<style lang="less" scoped>
.pressForMoneyDetail {
    width: 375px;
    background: #f2f2f2;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    .top-tips {
        // width: 375px;
        height: 34px;
        line-height: 34px;
        background: #FFF0D7;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: #F5834E;
        line-height: 34px;
        text-shadow: 0px 4px 10px rgba(0,0,0,0.1);
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 16px;
        box-shadow: 0px 4px 10px 0px rgba(0,0,0,0.1);
        img {
            width: 18px;
            height: 18px;
        }
    }
    .contain-box {
        // width: 359px;
        // height: 325px;
        background: #FFFFFF;
        margin: 0 8px;
        margin-top: 8px;
        padding: 16px;
        padding-top: 24px;
        .skill-item {
            .skill-title {
                height: 20px;
                font-size: 15px;
                color: #323233;
                line-height: 20px;
                display: flex;
                align-items: center;
                .skill-icon {
                    width: 10px;
                    height: 10px;
                    background: #FE4F51;
                    margin-right: 12px;
                    border-radius: 10px;
                    &.dis-icon {
                        background: #DCDEE0;
                        border: 3px solid #fff;
                    }
                }
            }
            .skill-desc {
                padding: 7px 19px;
                padding-bottom: 30px;
                border-left: 1px solid #FE4F51;
                margin-left: 7px;
                width: 299px;
                height: 18px;
                font-size: 13px;
                font-weight: 400;
                color: #969799;
                line-height: 18px;
                :last-child {
                    padding-bottom: 0;
                }
                &.dis-line {
                    border-left: 1px solid #DCDEE0;
                }
            }
            &:last-child {
                padding-bottom: 0;
            }
        }
    }
    .empty-class {
        text-align: center;
        margin: 0 auto;
        img {
            width: 180px;
            height: 180px;
            margin-top: 134px;
        }
        p {
            height: 18px;
            font-size: 15px;
            color: #999999;
            line-height: 18px;
            font-weight: 600;
            margin-top: 10px;
        }
    }
}
</style>
